import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { BillingSettingsPage } from '@/features/billing'

const billingSearchSchema = z.object({
  // Router may deserialize ?success=true as boolean or string
  success: z
    .union([z.string(), z.boolean()])
    .optional()
    .transform((value) => {
      if (value === undefined) return undefined
      if (typeof value === 'boolean') return value ? 'true' : undefined
      return value
    }),
})

/**
 * Billing route — bypasses the subscription check to prevent infinite redirect
 * loops. Users with expired/canceled subscriptions can still reach billing to
 * subscribe.
 *
 * Deliberately has NO role `beforeLoad` guard (BUG-102 residual, reviewed
 * 2026-07): a non-billing-manager who types this URL gets the read-only view
 * (see the banner in billing-settings.tsx:508-518, gated on canManageBilling).
 * That is DISCLOSURE of plan + payment history, not privilege escalation —
 * every mutating path is separately gated at the API (`settings.manage_billing`)
 * and at Stripe (`authorizeReference`).
 *
 * Adding a redirect here is a behaviour change, not a hardening: middleware.ts
 * :339 deliberately does not bounce staff on billing state. If the disclosure
 * is judged unacceptable, prefer hiding the payment-history + capacity CARDS
 * for non-managers over redirecting the route.
 */
export const Route = createFileRoute('/_authenticated/_organization/billing/')({
  validateSearch: billingSearchSchema,
  component: BillingSettingsPage,
})
